import styled from 'styled-components';

export const AlertRibbonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: inherit;
    background-color: rgba(217, 220, 224, 0.5);
    margin-bottom: 5px;
    padding: 12px 178px;
    @media screen and (max-width: 768px) {
        padding: 12px 90px;
    }
    @media screen and (max-width: 425px) {
        padding: 12px 20px;
    }
`;

export const AlertIcon = styled.img`
    height: 27.96px;
    width: 30px;
    margin-right: 18px;
    align-self: start;
    @media screen and (max-width: 768px) {
        margin-right: 20px;
    }
    @media screen and (max-width: 425px) {
        margin-right: 20px;
    }
`;
export const CloseButton = styled.button`
    border: none;
    margin-left: 92px;
    padding-bottom: 30px;
    padding-right: 30px;
    height: 18px;
    width: 18px;
    align-self: start;
    @media screen and (max-width: 768px) {
        margin-left: 42px;
    }
    @media screen and (max-width: 425px) {
        margin-left: 0;
    }
`;
export const AlertContents = styled.div`
    flex: 1;
    h6 {
        display: contents;
    }
    a {
        display: inline-block;
        font-weight: bold;
    }
`;
